module.exports = __webpack_public_path__ + "img/director-school-icon3.6d11c197.jpg";